import { MolsonTypography } from '@components/reusable'
import { Stack, Switch, type SwitchProps } from '@mui/material'

export type MolsonToggleProps = SwitchProps & {
  dataTestId?: string
  label?: string
}

export const MolsonToggle = ({
  dataTestId,
  label,
  ...props
}: MolsonToggleProps) => {
  return (
    <Stack
      spacing={1}
      direction="row"
      alignItems="center"
      data-testid={dataTestId}
    >
      <Switch {...props} />
      <MolsonTypography fontWeight={700}>{label}</MolsonTypography>
    </Stack>
  )
}
